import styles from "./SamplingEventActions.module.css";

// Sampling Event Actions

// New Sampling Event Button
export const NewSamplingEventButton = ({ newSamplingEventFunction }) => {
  return (
    <button
      className={styles.samplingEventButton}
      onClick={newSamplingEventFunction}
    >
      New Event
    </button>
  );
};

// Delete Sampling Event Button
export const DeleteSamplingEventButton = ({ deleteSamplingEventFunction }) => {
  return (
    <button
      className={styles.deleteSamplingEventButton}
      onClick={deleteSamplingEventFunction}
    >
      Delete Event
    </button>
  );
};

// Open Sampling Event Button
export const OpenSamplingEventButton = ({ openSamplingEventFunction }) => {
  return (
    <button
      className={styles.samplingEventButton}
      onClick={openSamplingEventFunction}
    >
      Open Event
    </button>
  );
};

// Well Uploads Button
export const WellUploadsButton = ({ openWellUploadsFunction }) => {
  return (
    <button
      className={styles.samplingEventButton}
      onClick={openWellUploadsFunction}
    >
      Well Uploads
    </button>
  );
};
